import { DateTime } from "luxon";
import { eventDateFormat } from "./getLatestEvent";


export const getTimestampFromStr = (datestr) => {
  return DateTime.fromFormat(datestr, eventDateFormat).toUnixInteger();
};
